import * as yup from "yup";
import { array, boolean, date, mixed, object, string } from "yup";

export const SkillVisibilitySchema = mixed<
  "PRIVATE" | "ORGANIZATION" | "GLOBAL" | "FORMLY_INTERNAL"
>()
  .oneOf(["PRIVATE", "ORGANIZATION", "GLOBAL", "FORMLY_INTERNAL"])
  .required();

const SkillUserSchema = object({
  id: string().uuid().required(),
  email: string().email().required(),
  firstName: string().nullable(),
  lastName: string().nullable(),
});

export const SkillMetadataSchema = object({
  id: string().uuid().required(),
  name: string().required(),
  descriptionMd: string().required(),
  visibility: SkillVisibilitySchema,
  organizationId: string().uuid().nullable(),
  createdByUserId: string().uuid().nullable().defined(),
  enabled: boolean().required(),
  forceEnabled: boolean().required().default(false),
  canEdit: boolean().required(),
  canDelete: boolean().required(),
  createdAt: date().required(),
  updatedAt: date().required(),
  createdByUser: SkillUserSchema.nullable().defined(),
});

export const SkillDetailSchema = SkillMetadataSchema.shape({
  contentMd: string().required(),
});

export const SkillListResponseSchema = object({
  skills: array().of(SkillMetadataSchema).required(),
});

export type SkillVisibility = yup.InferType<typeof SkillVisibilitySchema>;
export type SkillMetadata = yup.InferType<typeof SkillMetadataSchema>;
export type SkillDetail = yup.InferType<typeof SkillDetailSchema>;
export type SkillListFilter =
  | "all"
  | "mine"
  | "private"
  | "organization"
  | "global"
  | "formly_internal";

export type SkillWritePayload = {
  name: string;
  descriptionMd: string;
  contentMd: string;
  visibility: SkillVisibility;
  forceEnabled?: boolean;
};

export type SkillPatchPayload = Partial<SkillWritePayload>;
